import { OptionType, SORT_ORDER } from '@evinced-private/ui-common';

import {
	SEVERITIES_DISPLAY_MODE,
	SeveritiesDisplayMode,
	severitiesOrder,
	severityOptions
} from '../../consts/severity';

export const formatOldSeverityLabel = (label: string): string => `${label} (old)`;

export const getCustomSeverityOptionsList = (
	customSeverityNames: Record<string, string>,
	severitiesDisplayMode: SeveritiesDisplayMode = SEVERITIES_DISPLAY_MODE.ALL
): OptionType[] => {
	const customNames = new Set<string>(Object.values(customSeverityNames));
	const standardOptions: OptionType[] = [];
	const replacedOptions: OptionType[] = [];
	const result: OptionType[] = [];

	severityOptions.forEach(({ label, value }) => {
		if (customSeverityNames[value]) {
			replacedOptions.push({ label: formatOldSeverityLabel(label), value: label });
		} else {
			standardOptions.push({ label, value: label });
		}
	});

	const customOptions: OptionType[] = Array.from(customNames).map((label) => ({
		label,
		value: label
	}));

	result.push(...customOptions, ...standardOptions);

	if (severitiesDisplayMode === SEVERITIES_DISPLAY_MODE.ALL) {
		result.push(...replacedOptions);
	}

	return result;
};

export const sortSeverities = (severities: string[]): string[] => {
	const newSeveritites = [];
	// add all known severities by order
	severitiesOrder.forEach((severity) => {
		if (severities.includes(severity)) {
			newSeveritites.push(severity);
		}
	});
	// add all unknown severities in the end
	severities.forEach((severity) => {
		if (!newSeveritites.includes(severity)) {
			newSeveritites.push(severity);
		}
	});
	return newSeveritites;
};

export const sortBySeverity = (a: string, b: string, order: SORT_ORDER): number => {
	const aSeverityIndex = severitiesOrder.findIndex((severity) => severity === a);
	const bSeverityIndex = severitiesOrder.findIndex((severity) => severity === b);

	if (order === SORT_ORDER.ASC) {
		return bSeverityIndex - aSeverityIndex;
	}
	return aSeverityIndex - bSeverityIndex;
};
